var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h2',{staticClass:"secondary--text mb-3 mt-5"},[_vm._v("Familiestatuut App")]),_c('div',{staticClass:"body-1 grey--text text--darken-2"},[_vm._v(" Familiestatuut App, de consultancy methode van de toekomst... ")])])
}]

export { render, staticRenderFns }